import { render, staticRenderFns } from "./FormAlert.vue?vue&type=template&id=7060c4ec&"
import script from "./FormAlert.vue?vue&type=script&lang=js&"
export * from "./FormAlert.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports